(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-cph-header]').forEach(header => {
      if (header.dataset.cphReady) return;
      header.dataset.cphReady = 'true';
      header.querySelectorAll('[data-cph-open]').forEach(button => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.cphOpen);
          if (!dialog) return;
          header.querySelectorAll('dialog[open]').forEach(openDialog => openDialog.close());
          header.querySelectorAll('.cph-nav__item[open], .cph-locale[open]').forEach(item => item.open = false);
          dialog.showModal();
          document.body.classList.add('cph-dialog-open');
        });
      });
      header.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-cph-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => document.body.classList.toggle('cph-dialog-open', Boolean(header.querySelector('dialog[open]'))));
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      });
      const menus = [...header.querySelectorAll('.cph-nav__item, .cph-locale')];
      menus.forEach(menu => {
        menu.addEventListener('toggle', () => {
          if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
        });
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
        });
        if (matchMedia('(hover:hover)').matches && menu.classList.contains('cph-nav__item')) {
          let close;
          menu.querySelector('summary').addEventListener('click', event => { if (event.detail > 0 && menu.open) event.preventDefault(); });
          menu.addEventListener('pointerenter', () => { clearTimeout(close); menu.open = true; });
          menu.addEventListener('pointerleave', () => { close = setTimeout(() => { menu.open = false; }, 140); });
        }
      });
      document.addEventListener('click', event => { if (!header.contains(event.target)) menus.forEach(menu => menu.open = false); });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') menus.forEach(menu => menu.open = false); });
    });
    scope.querySelectorAll('[data-focus-products]').forEach(section => {
      if (section.dataset.focusReady) return;
      section.dataset.focusReady = 'true';
      const tabs = [...section.querySelectorAll('[data-pack-tab]')];
      const panels = [...section.querySelectorAll('[data-pack-panel]')];
      const activate = tab => {
        tabs.forEach(other => {
          const active = other === tab;
          other.setAttribute('aria-selected', String(active));
          other.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.packPanel !== tab.dataset.packTab; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const direction = getComputedStyle(section).direction === 'rtl' ? -1 : 1;
          const step = event.key === 'ArrowRight' ? direction : -direction;
          const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length - 1] : tabs[(index + step + tabs.length) % tabs.length];
          activate(target);
          target.focus();
        });
      });
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-sets]')) document.querySelector('[data-pack-tab="set"]')?.click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

